export const products = [
  {
    id: "heritage-sweater-natural",
    name: "Heritage Crew Sweater",
    shortDesc: "Classic knit in undyed natural wool",
    price: 189,
    category: "sweaters",
    colorPalette: "natural",
    farmId: "boerderij-roskam",
    farmName: "Boerderij Roskam",
    farmLocation: "Noordoostpolder + Oversijssel, Netherlands",
    image: "https://images.unsplash.com/photo-1601379327928-bedfaf9da2d0?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    images: [
      "https://images.unsplash.com/photo-1601379327928-bedfaf9da2d0?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1602706294170-1fed8eecd9f9?w=800&q=80",
      "https://images.unsplash.com/photo-1643313260651-9c335822ecde?w=800&q=80"
    ],
    tags: ["Traceable", "Local NL", "Waste-reduced wool"],
    materialComposition: "100% Dutch unique wool",
    traceability: {
      steps: [
        { name: "Shearing", date: "March 2025", partner: "Boerderij Roskam", location: "Noordoostpolder + Oversijssel, NL" },
        { name: "Sorting", date: "March 2025", partner: "WoolSort BV", location: "Den Helder, NL" },
        { name: "Cleaning", date: "April 2025", partner: "Wollwäscherei Schmidt", location: "Bremen, DE" },
        { name: "Spinning", date: "April 2025", partner: "Spinnerij Van der Berg", location: "Tilburg, NL" },
        { name: "Knitting", date: "May 2025", partner: "Breifabriek Leiden", location: "Leiden, NL" },
        { name: "Finishing", date: "May 2025", partner: "WoolStory Atelier", location: "Amsterdam, NL" }
      ],
      lastUpdated: "2025-05-15"
    },
    impact: {
      wasteAddressed: "Leftover wool from Texel sheep that would otherwise be discarded after annual shearing.",
      metric: "~150g wool saved",
      methodology: "Weight calculated from average fleece yield minus commercially viable portion."
    },
    storyPreview: "This sweater carries the warmth of Texel Island, where the Van den Berg family has raised sheep for four generations. Each spring, their flock grazes on the salty meadows near the Wadden Sea, producing wool with unique resilience.",
    sizing: {
      fit: "Regular fit with slightly relaxed shoulders",
      model: "Model wears size M, height 178cm",
      guide: [
        { size: "XS", chest: "86-91cm", length: "62cm" },
        { size: "S", chest: "91-96cm", length: "64cm" },
        { size: "M", chest: "96-101cm", length: "66cm" },
        { size: "L", chest: "101-106cm", length: "68cm" },
        { size: "XL", chest: "106-112cm", length: "70cm" }
      ]
    },
    care: {
      summary: "Hand wash cold, lay flat to dry. Wool naturally resists odors and stains.",
      instructions: [
        "Hand wash in cold water with wool detergent",
        "Do not wring or twist",
        "Lay flat on a towel to dry",
        "Reshape while damp",
        "Store folded, not hung"
      ]
    }
  },
  {
    id: "meadow-blanket-oatmeal",
    name: "Meadow Throw Blanket",
    shortDesc: "Generously sized in soft oatmeal tones",
    price: 245,
    category: "blankets",
    colorPalette: "neutral",
    farmId: "hoeve-het-schaap",
    farmName: "Hoeve Het Schaap",
    farmLocation: "Drenthe, Netherlands",
    image: "https://images.unsplash.com/photo-1590925862651-2112d98d9ae0?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1590925862651-2112d98d9ae0?w=800&q=80",
      "https://images.unsplash.com/photo-1595026525047-dfa997df8a4a?w=800&q=80"
    ],
    tags: ["Traceable", "Local NL/DE", "Waste-reduced wool"],
    materialComposition: "100% Dutch Drenthe Heath sheep wool",
    traceability: {
      steps: [
        { name: "Shearing", date: "April 2025", partner: "Hoeve Het Schaap", location: "Drenthe, NL" },
        { name: "Sorting", date: "April 2025", partner: "WoolSort BV", location: "Groningen, NL" },
        { name: "Cleaning", date: "May 2025", partner: "Wollwäscherei Schmidt", location: "Bremen, DE" },
        { name: "Spinning", date: "May 2025", partner: "Wolspinnerij Veendam", location: "Veendam, NL" },
        { name: "Weaving", date: "June 2025", partner: "Weverij Overijssel", location: "Almelo, NL" },
        { name: "Finishing", date: "June 2025", partner: "WoolStory Atelier", location: "Amsterdam, NL" }
      ],
      lastUpdated: "2025-06-20"
    },
    impact: {
      wasteAddressed: "Coarse outer wool from Drenthe Heath sheep, traditionally discarded due to limited demand.",
      metric: "~280g wool saved",
      methodology: "Based on typical blanket wool weight from heritage breed fleece."
    },
    storyPreview: "From the misty heathlands of Drenthe comes this blanket, woven from the wool of Drenthe Heath sheep. The Bakker family maintains this rare Dutch breed, whose coarse yet beautiful wool was once considered too rustic for modern taste.",
    sizing: {
      fit: "Generous throw size",
      dimensions: "150cm x 200cm",
      guide: [{ size: "One Size", width: "150cm", length: "200cm" }]
    },
    care: {
      summary: "Spot clean or dry clean. Air regularly to refresh.",
      instructions: [
        "Spot clean with damp cloth",
        "Professional dry clean for deep cleaning",
        "Air outside on dry days",
        "Store in breathable bag"
      ]
    }
  },
  {
    id: "coastal-cardigan-slate",
    name: "Coastal Cardigan",
    shortDesc: "Chunky knit in weathered slate grey",
    price: 215,
    category: "sweaters",
    colorPalette: "grey",
    farmId: "boerderij-roskam",
    farmName: "Boerderij Roskam",
    farmLocation: "Noordoostpolder + Oversijssel, Netherlands",
    image: "https://images.unsplash.com/photo-1636716018960-eb737dccb185?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1636716018960-eb737dccb185?w=800&q=80",
      "https://images.unsplash.com/photo-1602706294170-1fed8eecd9f9?w=800&q=80"
    ],
    tags: ["Traceable", "Local NL", "Waste-reduced wool"],
    materialComposition: "100% Dutch unique wool, naturally dyed",
    traceability: {
      steps: [
        { name: "Shearing", date: "March 2025", partner: "Boerderij Roskam", location: "Noordoostpolder + Oversijssel, NL" },
        { name: "Sorting", date: "March 2025", partner: "WoolSort BV", location: "Den Helder, NL" },
        { name: "Cleaning", date: "April 2025", partner: "Wollwäscherei Schmidt", location: "Bremen, DE" },
        { name: "Dyeing", date: "April 2025", partner: "Natuurlijke Verven", location: "Utrecht, NL" },
        { name: "Spinning", date: "May 2025", partner: "Spinnerij Van der Berg", location: "Tilburg, NL" },
        { name: "Knitting", date: "May 2025", partner: "Breifabriek Leiden", location: "Leiden, NL" }
      ],
      lastUpdated: "2025-05-28"
    },
    impact: {
      wasteAddressed: "Grey-toned wool from Texel sheep typically rejected by commercial buyers.",
      metric: "~180g wool saved",
      methodology: "Calculated from fleece sorting records at partner facilities."
    },
    storyPreview: "The slate grey tones of this cardigan come from the natural variation in Texel wool, enhanced with plant-based dyes from local sources. Each piece shows subtle variations that tell of its handcrafted origin.",
    sizing: {
      fit: "Relaxed oversized fit",
      model: "Model wears size S, height 168cm",
      guide: [
        { size: "XS", chest: "100cm", length: "68cm" },
        { size: "S", chest: "106cm", length: "70cm" },
        { size: "M", chest: "112cm", length: "72cm" },
        { size: "L", chest: "118cm", length: "74cm" }
      ]
    },
    care: {
      summary: "Hand wash cold with wool detergent. Natural dyes may fade slightly with washing.",
      instructions: [
        "Hand wash in cold water",
        "Use pH-neutral wool detergent",
        "Do not soak for extended periods",
        "Dry flat away from direct sunlight"
      ]
    }
  },
  {
    id: "highland-scarf-heather",
    name: "Highland Wool Scarf",
    shortDesc: "Luxuriously long in heathered purple",
    price: 85,
    category: "accessories",
    colorPalette: "warm",
    farmId: "schapenboerderij-noord",
    farmName: "Schapenboerderij Noord",
    farmLocation: "Friesland, Netherlands",
    image: "https://images.unsplash.com/photo-1563136192-a4b2b5f977e1?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1563136192-a4b2b5f977e1?w=800&q=80"
    ],
    tags: ["Traceable", "Local NL", "Waste-reduced wool"],
    materialComposition: "100% Dutch Frisian wool blend",
    traceability: {
      steps: [
        { name: "Shearing", date: "April 2025", partner: "Schapenboerderij Noord", location: "Friesland, NL" },
        { name: "Sorting", date: "April 2025", partner: "Wol Collectief Friesland", location: "Leeuwarden, NL" },
        { name: "Cleaning", date: "May 2025", partner: "Texelse Wol", location: "Texel, NL" },
        { name: "Spinning", date: "May 2025", partner: "Spinnerij Van der Berg", location: "Tilburg, NL" },
        { name: "Knitting", date: "June 2025", partner: "WoolStory Atelier", location: "Amsterdam, NL" }
      ],
      lastUpdated: "2025-06-10"
    },
    impact: {
      wasteAddressed: "Mixed-color fleece portions typically considered too variegated for commercial use.",
      metric: "~65g wool saved",
      methodology: "Weight based on finished scarf using waste-grade wool inputs."
    },
    storyPreview: "This scarf celebrates the natural color variations in Frisian wool. The de Jong family's flock produces fleeces in dozens of natural shades, which we blend to create this unique heathered effect.",
    sizing: {
      fit: "Generous wrap length",
      dimensions: "30cm x 200cm",
      guide: [{ size: "One Size", width: "30cm", length: "200cm" }]
    },
    care: {
      summary: "Hand wash or machine wash on wool setting. Reshape while damp.",
      instructions: [
        "Hand wash or gentle machine wash cold",
        "Use wool-specific detergent",
        "Do not tumble dry",
        "Lay flat or hang to dry"
      ]
    }
  },
  {
    id: "farmhouse-cushion-cream",
    name: "Farmhouse Cushion Cover",
    shortDesc: "Textured weave in warm cream",
    price: 75,
    category: "home",
    colorPalette: "natural",
    farmId: "hoeve-het-schaap",
    farmName: "Hoeve Het Schaap",
    farmLocation: "Drenthe, Netherlands",
    image: "https://images.unsplash.com/photo-1643313260651-9c335822ecde?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1643313260651-9c335822ecde?w=800&q=80"
    ],
    tags: ["Traceable", "Local NL/DE", "Waste-reduced wool"],
    materialComposition: "100% Dutch wool, cotton backing",
    traceability: {
      steps: [
        { name: "Shearing", date: "April 2025", partner: "Hoeve Het Schaap", location: "Drenthe, NL" },
        { name: "Sorting", date: "April 2025", partner: "WoolSort BV", location: "Groningen, NL" },
        { name: "Cleaning", date: "May 2025", partner: "Wollwäscherei Schmidt", location: "Bremen, DE" },
        { name: "Weaving", date: "June 2025", partner: "Weverij Overijssel", location: "Almelo, NL" },
        { name: "Sewing", date: "June 2025", partner: "WoolStory Atelier", location: "Amsterdam, NL" }
      ],
      lastUpdated: "2025-06-25"
    },
    impact: {
      wasteAddressed: "Short fiber wool from sorting process, unsuitable for spinning but perfect for textured weaving.",
      metric: "~90g wool saved",
      methodology: "Based on cushion face weight from recovered short-staple fibers."
    },
    storyPreview: "This cushion cover uses the shorter fibers from Drenthe Heath sheep wool—fibers that would normally be discarded during the sorting process. We've developed a special weaving technique that transforms them into beautiful texture.",
    sizing: {
      fit: "Standard cushion size",
      dimensions: "45cm x 45cm",
      guide: [{ size: "Standard", width: "45cm", height: "45cm" }]
    },
    care: {
      summary: "Spot clean only. Remove cover from cushion insert for cleaning.",
      instructions: [
        "Spot clean with damp cloth",
        "Do not machine wash",
        "Air dry only",
        "Professional cleaning recommended for heavy soiling"
      ]
    }
  },
  {
    id: "winter-beanie-charcoal",
    name: "Winter Wool Beanie",
    shortDesc: "Classic ribbed style in charcoal",
    price: 55,
    category: "accessories",
    colorPalette: "grey",
    farmId: "boerderij-roskam",
    farmName: "Boerderij Roskam",
    farmLocation: "Noordoostpolder + Oversijssel, Netherlands",
    image: "https://images.unsplash.com/photo-1646270968802-6bad28659329?w=600&q=80",
    images: [
      "https://images.unsplash.com/photo-1646270968802-6bad28659329?w=800&q=80"
    ],
    tags: ["Traceable", "Local NL", "Waste-reduced wool"],
    materialComposition: "100% Dutch unique wool",
    traceability: {
      steps: [
        { name: "Shearing", date: "March 2025", partner: "Boerderij Roskam", location: "Noordoostpolder + Oversijssel, NL" },
        { name: "Sorting", date: "March 2025", partner: "WoolSort BV", location: "Den Helder, NL" },
        { name: "Cleaning", date: "April 2025", partner: "Texelse Wol", location: "Texel, NL" },
        { name: "Spinning", date: "April 2025", partner: "Spinnerij Van der Berg", location: "Tilburg, NL" },
        { name: "Knitting", date: "May 2025", partner: "WoolStory Atelier", location: "Amsterdam, NL" }
      ],
      lastUpdated: "2025-05-10"
    },
    impact: {
      wasteAddressed: "Dark-colored wool fibers from Texel sheep fleeces, often rejected in sorting.",
      metric: "~45g wool saved",
      methodology: "Beanie weight using reclaimed dark fiber portions."
    },
    storyPreview: "This beanie celebrates the darker wool that naturally occurs in some Texel sheep. Rather than blending it away, we've embraced these beautiful charcoal tones to create a versatile cold-weather essential.",
    sizing: {
      fit: "Stretchy ribbed fit",
      model: "One size fits most adults",
      guide: [{ size: "One Size", circumference: "52-58cm" }]
    },
    care: {
      summary: "Hand wash cold, reshape and lay flat to dry.",
      instructions: [
        "Hand wash in cold water",
        "Gently squeeze, do not wring",
        "Reshape while damp",
        "Dry flat away from heat"
      ]
    }
  }
];

export const categories = [
  { id: "all", name: "All Products" },
  { id: "sweaters", name: "Sweaters" },
  { id: "blankets", name: "Blankets" },
  { id: "accessories", name: "Accessories" },
  { id: "home", name: "Home" }
];

export const colorPalettes = [
  { id: "all", name: "All Colors" },
  { id: "natural", name: "Natural / Cream" },
  { id: "neutral", name: "Neutral / Oatmeal" },
  { id: "grey", name: "Grey / Charcoal" },
  { id: "warm", name: "Warm / Heather" }
];

export const priceRanges = [
  { id: "all", name: "All Prices", min: 0, max: Infinity },
  { id: "under-100", name: "Under €100", min: 0, max: 100 },
  { id: "100-200", name: "€100 - €200", min: 100, max: 200 },
  { id: "over-200", name: "Over €200", min: 200, max: Infinity }
];
